/**
 * A tab that loaded index.html before a deploy can fail to fetch lazily loaded
 * chunks afterwards (Chrome: "Failed to fetch dynamically imported module",
 * Safari: "Importing a module script failed"). Vite surfaces those failures as
 * a `vite:preloadError` event on window; reloading picks up the new
 * index.html and the new chunk hashes.
 *
 * The reload is rate-limited via sessionStorage so failures that a reload
 * cannot fix (offline, adblocker) fall through to the error boundary instead
 * of reload-looping.
 */

const MIN_RELOAD_INTERVAL_MS = 60_000;
const LAST_RELOAD_STORAGE_KEY = 'aline:last-chunk-failure-reload';

export function installChunkLoadRecovery(): void {
  window.addEventListener('vite:preloadError', event => {
    if (reloadAfterAssetLoadFailure()) {
      // Suppress the error so Sentry/error boundaries don't fire for a recoverable blip.
      event.preventDefault();
    }
  });
}

export function reloadAfterAssetLoadFailure(reload = () => window.location.reload()): boolean {
  const lastReloadAt = Number(sessionStorage.getItem(LAST_RELOAD_STORAGE_KEY) ?? 0);
  if (Date.now() - lastReloadAt < MIN_RELOAD_INTERVAL_MS) return false;

  sessionStorage.setItem(LAST_RELOAD_STORAGE_KEY, String(Date.now()));
  reload();
  return true;
}
